<template>
  <div class="admin-dashboard">
    <!-- Cards de Estatísticas -->
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-clipboard-list"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ estatisticas.total_concursos || 0 }}</div>
          <div class="stat-label">Total de Concursos</div>
        </div>
        <div class="stat-trend neutral">
          <i class="fas fa-minus"></i>
          <span>0%</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-door-open"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ estatisticas.concursos_abertos || 0 }}</div>
          <div class="stat-label">Concursos Abertos</div>
        </div>
        <div class="stat-trend positive">
          <i class="fas fa-arrow-up"></i>
          <span>Ativos</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-users"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ estatisticas.total_inscricoes || 0 }}</div>
          <div class="stat-label">Total de Inscrições</div>
        </div>
        <div class="stat-trend neutral">
          <i class="fas fa-minus"></i>
          <span>0%</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-percentage"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ estatisticas.isencoes_pendentes || 0 }}</div>
          <div class="stat-label">Isenções Pendentes</div>
        </div>
        <div class="stat-trend warning">
          <i class="fas fa-clock"></i>
          <span>Pendentes</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-gavel"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ estatisticas.recursos_pendentes || 0 }}</div>
          <div class="stat-label">Recursos Pendentes</div>
        </div>
        <div class="stat-trend warning">
          <i class="fas fa-clock"></i>
          <span>Pendentes</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-dollar-sign"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">R$ {{ formatarValor(estatisticas.receita_total) }}</div>
          <div class="stat-label">Valor Inscrições</div>
        </div>
        <div class="stat-trend neutral">
          <i class="fas fa-minus"></i>
          <span>0%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdminDashboard',
  data() {
    return {
      loading: false,
      estatisticas: {}
    }
  },
  mounted() {
    this.carregarEstatisticas()
  },
  methods: {
    async carregarEstatisticas() {
      this.loading = true
      try {
        const { data } = await axios.get('/ps/concurso/estatisticas')
        this.estatisticas = data
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error)
        this.$sweet.showError('Erro ao carregar estatísticas')
      } finally {
        this.loading = false
      }
    },
    formatarValor(valor) {
      if (!valor) return '0,00'
      return parseFloat(valor).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  }
}
</script>

<style scoped>
.admin-dashboard {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  color: #2d3748;
  line-height: 1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

.stat-trend {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
}

.stat-trend.positive {
  background: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.stat-trend.negative {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.stat-trend.warning {
  background: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.stat-trend.neutral {
  background: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .admin-dashboard {
    padding: 15px;
  }
  
  .stat-card {
    padding: 20px;
  }
  
  .stat-number {
    font-size: 28px;
  }
}
</style>